import React from "react";
import { useLocation } from "react-router-dom";
import CheckoutForm from "./checkoutForm";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import { Helmet } from "react-helmet";

const stripePromise = loadStripe(
  "pk_test_51PLoMQDPGZKo4YmHfEXmkp6w54oeYMczZ92B5bNvST5qj2NFdrAcLHGJAfEh0MmOn2lVxP1xGBlSbiK3zJ7ilgwP004JRyTt9W"
);

function Checkout() {

  const location = useLocation();
  const { subscriptionData } = location.state || {};

  console.log("subscriptionData:", subscriptionData);

 

  return (
    
    <Elements stripe={stripePromise}>
  <Helmet>
  <title>Secure Checkout – PrepNexa AI-Powered PTE Practice</title>
  <meta
    name="description"
    content="Complete your PrepNexa purchase securely. Get access to AI-powered PTE mock tests, real-time scoring, and personalized feedback to boost your exam prep."
  />
  <meta
    name="keywords"
    content="PrepNexa checkout, PTE mock test payment, secure PTE practice, PTE plan purchase, AI PTE exam prep"
  />
  <meta name="robots" content="noindex, nofollow" />
  <meta name="author" content="PrepNexa Team" />
  <link rel="canonical" href="https://prepnexa.com/checkout" />

  {/* Open Graph Tags */}
  <meta property="og:type" content="website" />
  <meta property="og:title" content="Secure Checkout – PrepNexa AI-Powered PTE Practice" />
  <meta
    property="og:description"
    content="Finish your purchase and unlock full access to PrepNexa’s PTE prep tools, mock tests, and instant scoring system."
  />
  <meta property="og:url" content="https://prepnexa.com/checkout" />
  <meta property="og:image" content="https://prepnexa.com/images/checkout-banner.png" />

  {/* Twitter Card */}
  <meta name="twitter:card" content="summary_large_image" />
  <meta name="twitter:title" content="Secure Checkout – PrepNexa" />
  <meta
    name="twitter:description"
    content="Fast and secure checkout to access AI-powered PTE mock tests and real-time scoring with PrepNexa."
  />
  <meta name="twitter:image" content="https://prepnexa.com/images/checkout-banner.png" />
</Helmet>

      <CheckoutForm subscriptionData={subscriptionData}/>
    </Elements>
  );
}

export default Checkout;
